import GoalsStaticText from "./GoalsStaticText";
import GoalsInput from "./GoalsInput";
import { ICareerGoalsProps } from "../types/interfaces/ICareerGoalsProps";
import { Divider} from "@mui/material";

//This component is responsible for rendering the career goals. 
const CareerGoals: React.FC<ICareerGoalsProps> = ({ isReadOnly, goals, onGoalsChange }) =>  {
    //Function to handle goals change.
    const handleGoalsChange = (changedGoals: string) => {
        onGoalsChange(changedGoals);
    };

    return (
        <>
            <GoalsStaticText />
            <GoalsInput isReadOnly={isReadOnly} goals={goals} onGoalsChange={handleGoalsChange} />
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}

export default CareerGoals;